var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?[(_vm.content)?_c('company-info',{attrs:{"content":_vm.content}}):_c('farm-view',{attrs:{"currentMapInfo":_vm.currentFarm}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }